import React from "react";
import { Link } from "react-router-dom";
import { getApplicationStatusClass } from "../utils/driverStatus";

function formatDate(value) {
  if (!value) return "—";

  try {
    return new Date(value).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "—";
  }
}

function trimValue(value) {
  return String(value ?? "").trim() || "—";
}

function DriverCard({ driver, returnTo = "/Dashboard" }) {
  const profileImageUrl = driver?.profilePicturePath
    ? `${process.env.REACT_APP_BASE_URL_IMG}${driver.profilePicturePath}`
    : null;
  const displayName = trimValue(driver?.fullName);
  const statusLabel = trimValue(
    driver?.applicationStatusLocalized || driver?.applicationStatus
  );

  return (
    <Link
      to={`/Details/${driver.uuid}`}
      state={{ item: driver, returnTo }}
      className="dashboard-driver-card"
      aria-label={`View ${displayName} profile`}
    >
      <div
        className={`dashboard-driver-card__avatar${
          profileImageUrl ? " dashboard-driver-card__avatar--photo" : ""
        }`}
      >
        {profileImageUrl ? (
          <img
            src={profileImageUrl}
            alt={displayName}
            onError={(e) => {
              e.target.style.display = "none";
              e.target.parentElement.classList.remove(
                "dashboard-driver-card__avatar--photo"
              );
            }}
          />
        ) : (
          <i className="fa fa-user" aria-hidden="true"></i>
        )}
      </div>

      <h4 className="dashboard-driver-card__name">{displayName}</h4>

      <div className="dashboard-driver-card__rating">
        <i className="fa fa-star driver-rating-star" aria-hidden="true"></i>
        <span>{driver?.rating ?? "—"}</span>
      </div>

      <span className={getApplicationStatusClass(driver?.applicationStatus)}>
        {statusLabel}
      </span>

      <p className="dashboard-driver-card__car">
        {trimValue(driver?.carModel)}
        {driver?.carPlateNumber ? (
          <span className="dashboard-driver-card__plate">
            {trimValue(driver.carPlateNumber)}
          </span>
        ) : null}
      </p>

      <p className="dashboard-driver-card__meta">
        Joined {formatDate(driver?.dateCreated)}
      </p>
    </Link>
  );
}

export default DriverCard;
